export const TASK_STATUS_FILTER_PARAM = 't.status'

/** Default Task Management statuses: everything except archived. */
export const DEFAULT_TASK_STATUS_FILTER = [
  'in_progress',
  'pending',
  'completed',
  'closed',
  'outstanding',
] as const

export type TaskStatusOption = (typeof DEFAULT_TASK_STATUS_FILTER)[number] | 'archived'

export function getDefaultTaskFilterParams(): Record<string, string[]> {
  return {
    [TASK_STATUS_FILTER_PARAM]: [...DEFAULT_TASK_STATUS_FILTER],
  }
}
